import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NeoSuspensionServicioDTO } from '../../../Model/neoSuspensionServicioDTO';
import { AdministracionFechasYRangosService } from '../../../Service/administracion-fechas-y.rangos.service';
import { AlertService } from 'src/app/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

@Component({
    selector: 'app-crear-parametrizacion',
    templateUrl: './crear-parametrizacion.component.html',
    styleUrls: ['./crear-parametrizacion.component.scss'],
    standalone: false
})
export class CrearParametrizacionComponent implements OnInit {

  editar = false;
  isCreado = false;
  idNeoCliente: any;
  idUsuario: any;
  idSuspensionServicio: any;
  fechaActual: String = new Date().toLocaleDateString('en-CA');
  administrarFechasyHorasForm: UntypedFormGroup;
  neoSuspensionEdit: NeoSuspensionServicioDTO =
    new NeoSuspensionServicioDTO(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );


  constructor(
    private formBuilder: UntypedFormBuilder,
    protected fechasYRangosService: AdministracionFechasYRangosService,
    private alertService: AlertService,
    protected userIntermediarioService: UserService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private _sweetAlert:SweetAlertService
  ) {
    this.administrarFechasyHorasForm = this.formBuilder.group({
      fechaInicial: ['', Validators.required],
      fechaFinal: ['', Validators.required],
      horaInicial: ['', Validators.required],
      horaFinal: ['', Validators.required],
      justificacion: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.idSuspensionServicio = this.activatedRoute.snapshot.paramMap.get('id');
    this.cargarIdNeoCliente();
    this.cargarDatosParaEditar();
  }

  cargarIdNeoCliente() {
    this.idNeoCliente = this.userIntermediarioService.getUser().idCliente;
    this.idUsuario = this.userIntermediarioService.getUser().idUsuario;
  }

  validateField(key: string, item: string) {
    if (key === '') {
      return this.administrarFechasyHorasForm.get(item).dirty && this.administrarFechasyHorasForm.get(item).invalid;
    } else {
      return this.administrarFechasyHorasForm.get(key).get(item).dirty && this.administrarFechasyHorasForm.get(key).get(item).invalid;
    }
  }

  guardarDatosHorarios() {
  var fecha1 = this.administrarFechasyHorasForm.get('fechaInicial').value;
  var fecha2 = this.administrarFechasyHorasForm.get('fechaFinal').value;
    if(fecha2>=fecha1){
      const body: any = {
        fechaFinSuspension: this.administrarFechasyHorasForm.get('fechaFinal').value + 'T' + this.administrarFechasyHorasForm.get('horaFinal').value+'-05:00',
        fechaInicioSuspension: this.administrarFechasyHorasForm.get('fechaInicial').value + 'T' + this.administrarFechasyHorasForm.get('horaInicial').value+'-05:00',
        idCliente: this.idNeoCliente,
        justificacion: this.administrarFechasyHorasForm.get('justificacion').value,
        idUsuario: this.idUsuario
      };
      this.fechasYRangosService.guardarDatosHorarios(body).subscribe((data: any) => {
          if (data.exitoso == true) {
            this._sweetAlert.successModal("Cambios Guardados")
              .then((result)=>{
                if(result.isConfirmed){
                  this.router.navigate(['/intermediario/administracion/administracionFechayHora']);
                }
              });
            // $('#crearModal').modal('show');
          } else {
            this._sweetAlert.errorModal("Error!",true,data.error);
          }
          this.isCreado = true;
      });
    }if(fecha1>fecha2){
      this._sweetAlert.errorModal("Error!",true,'La fecha inicial no puede ser mayor a la fecha final');
    }

  }
  editarDatosHorarios() {
    var fecha1 = this.administrarFechasyHorasForm.get('fechaInicial').value;
    var fecha2 = this.administrarFechasyHorasForm.get('fechaFinal').value;
    if(fecha2>=fecha1){
      const body: any = {
        idSuspensionServicio: this.neoSuspensionEdit.idSuspensionServicio,
        fechaFinSuspension: this.administrarFechasyHorasForm.get('fechaFinal').value + 'T' + this.administrarFechasyHorasForm.get('horaFinal').value+'-05:00',
        fechaInicioSuspension: this.administrarFechasyHorasForm.get('fechaInicial').value + 'T' + this.administrarFechasyHorasForm.get('horaInicial').value+'-05:00',
        idCliente: this.idNeoCliente,
        justificacion: this.administrarFechasyHorasForm.get('justificacion').value,
        idUsuario: this.idUsuario
      };
      this.fechasYRangosService.editarDatosHorarios(body).subscribe(
          (data:any) => {
            if (data.exitoso == true) {
              this._sweetAlert.successModal("Cambios Guardados")
              .then((result)=>{
                if(result.isConfirmed){
                  this.router.navigate(['/intermediario/administracion/administracionFechayHora']);
                }
              });
              // $('#modificarModal').modal('show');
            } else {
              this._sweetAlert.errorModal("Error!",true,data.error);
            }
            this.isCreado = true;
      });
    }if(fecha1>fecha2){
      this._sweetAlert.errorModal("Error!",true,'La fecha inicial no puede ser mayor a la fecha final');
    }

  }

  cargarDatosParaEditar() {
    if (this.idSuspensionServicio) {
      this.editar = true;
      this.cargarDatosHorariosPorID();
    }
  }

  cargarDatosHorariosPorID() {
    this.fechasYRangosService
      .datosHorarioPorID(this.idSuspensionServicio)
      .subscribe(
        (data) => {
          this.neoSuspensionEdit = data;
         this.cargarDatosHorarios();
        },
        (err) => {
          this._sweetAlert.errorModal("Error!",true,err);
        }
      );
  }

  setearDatosHorarios(nombreCampo: string, valor: any) {
    this.administrarFechasyHorasForm.controls[nombreCampo].setValue(valor);
  }

  cargarDatosHorarios() {
    this.setearDatosHorarios(
      'fechaInicial',
      this.neoSuspensionEdit.fechaInicial
    );
    this.setearDatosHorarios(
      'fechaFinal',
      this.neoSuspensionEdit.fechaFinal
    );
    this.setearDatosHorarios(
      'horaInicial',
      this.neoSuspensionEdit.horaInicial
    );
   this.setearDatosHorarios(
     'horaFinal',
      this.neoSuspensionEdit.horaFinal
   )
    this.setearDatosHorarios(
      'justificacion',
      this.neoSuspensionEdit.justificacion
    );
  }

  aceptar() {
    $('#crearModal').modal('hide');
    $('#modificarModal').modal('hide');
    this.router.navigate(['/intermediario/administracion/administracionFechayHora']);
  }
}
